import { useState } from "react";
import { Play, Trash2, RefreshCw, ChevronDown } from "lucide-react";
import "../styles/algorithm-controls.css";
import Button from "../../shared/Button";

export default function AlgorithmControls({
  algorithm,
  setAlgorithm,
  isRunning,
  runAlgorithm,
  handleClear,
  speed,
  setSpeed,
  generateRandomCities,
}) {
  const [showDropdown, setShowDropdown] = useState(false);
  const [cityCount, setCityCount] = useState(5);

  const algorithms = {
    nearestNeighbor: "Nearest Neighbor",
    twoOpt: "2-Opt",
    bruteForce: "Brute Force (exact)",
    genetic: "Genetic Algorithm",
  };

  return (
    <div className="tspalgorithm-controls">
      <h3>Algorithm Controls</h3>

      <div className="tspcontrol-group">
        <label>Algorithm:</label>
        <div className="tsp-dropdown">
          <button
            className="tsp-dropdown-trigger"
            onClick={() => setShowDropdown(!showDropdown)}
            disabled={isRunning}
          >
            <span>{algorithms[algorithm]}</span>
            <ChevronDown
              className="dropdown-icon"
              style={{ transform: showDropdown ? "rotate(180deg)" : "none" }}
            />
          </button>

          {showDropdown && (
            <div className="tsp-dropdown-menu">
              {Object.entries(algorithms).map(([key, name]) => (
                <button
                  key={key}
                  className={`tsp-dropdown-item ${algorithm === key ? "active" : ""}`}
                  onClick={() => {
                    setAlgorithm(key);
                    setShowDropdown(false);
                  }}
                >
                  {name}
                </button>
              ))}
            </div>
          )}
        </div>
      </div>

      <div className="tspcontrol-group">
        <label>Animation Speed:</label>
        <input
          type="range"
          min="1"
          max="100"
          value={speed}
          onChange={(e) => setSpeed(Number.parseInt(e.target.value))}
          disabled={isRunning}
          className="tspspeed-slider"
        />
      </div>

      <div className="tspcontrol-group">
        <label>Random Cities:</label>
        <div className="random-cities-control">
          <input
            type="number"
            min="3"
            max="20"
            value={cityCount}
            onChange={(e) => setCityCount(Number.parseInt(e.target.value))}
            disabled={isRunning}
            className="city-count-input"
          />
          <Button variant="secondary" size="sm" onClick={() => generateRandomCities(cityCount)} disabled={isRunning} title="Generate random cities">
            <RefreshCw size={16} />
          </Button>
        </div>
      </div>

      <div className="button-group">
        <Button onClick={runAlgorithm} disabled={isRunning}>
          <Play size={16} /> Run Algorithm
        </Button>
        <Button variant="danger" onClick={handleClear}>
          <Trash2 size={16} /> Clear All
        </Button>
      </div>
    </div>
  );
}
